// ui/Input · Select · Textarea · Field — the form controls (Design Standard v1).
// Field puts the label 4px above its control and owns hint/error text, so an error
// is always a plain sentence next to the thing that's wrong. Styles in ds.css.
import React, { useId } from 'react';
import clsx from 'clsx';
import './ds.css';

export const Input = React.forwardRef(function Input({ className = '', size, invalid, ...props }, ref) {
  return <input ref={ref} className={clsx('ds-input', className)} aria-invalid={invalid || undefined} {...props} />;
});

export const Select = React.forwardRef(function Select({ className = '', invalid, children, ...props }, ref) {
  return (
    <select ref={ref} className={clsx('ds-select', className)} aria-invalid={invalid || undefined} {...props}>
      {children}
    </select>
  );
});

export const Textarea = React.forwardRef(function Textarea({ className = '', invalid, ...props }, ref) {
  return <textarea ref={ref} className={clsx('ds-textarea', className)} aria-invalid={invalid || undefined} {...props} />;
});

/** <Field label="Phone" hint="Any format" error={err}>{(id) => <Input id={id} … />}</Field> */
export function Field({ label, hint, error, className = '', children }) {
  const id = useId();
  return (
    <div className={clsx('ds-field', className)}>
      {label ? <label className="ds-field__label" htmlFor={id}>{label}</label> : null}
      {typeof children === 'function' ? children(id) : children}
      {error ? <span className="ds-field__error" role="alert">{error}</span> : hint ? <span className="ds-field__hint">{hint}</span> : null}
    </div>
  );
}

Input.displayName = 'Input';
export default Input;
